// JavaScript Document
import resizeWindow from './resizeWindow.js'
//this.load.image('bg', require('./image/background.png').default);目前會出錯
 //this.load.image('bg', require('./image/background.png'));
 //this.load.image('bg', BGimg);

export default class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'PreloadScene' })
  }

  preload() {
    //獲取當前網址，如： http://localhost:8080/Tmall/index.jsp
    var curWwwPath=window.document.location.href;

    //獲取主機地址之後的目錄如：/Tmall/index.jsp
    var pathName=window.document.location.pathname;
    var pos=curWwwPath.indexOf(pathName);

    //獲取主機地址，如： http://localhost:8080
    var localhostPaht=curWwwPath.substring(0,pos);

    //獲取帶”/”的專案名，如：/Tmall
    var projectName=pathName.substring(0,pathName.substr(1).indexOf(`/`), 1);

    console.log(projectName);
    this.load.image('bg', "./image/star-night.png");
    //resizeWindow;
    //this.load.image('bg', 'BGIMAGE');

  	this.load.image('ground', './image/platform.png')
    this.load.image('underground','./image/underground.png')
    this.load.image('logo', './image/diamond.png');
    this.load.image('red', './image/red.png');
	  this.load.image('star', './image/diamond.png');
  	this.load.image('bomb', './image/bomb.png');
	  //this.load.spritesheet('dude', './image/dude.png', {
			//frameWidth: 32, frameHeight: 48
		//});
    this.load.spritesheet('dude', './image/dude2.png', {
			frameWidth: 48, frameHeight: 55
		});
  }

  create() {
    //const startX= 800/2;
    //const startY= 600/2;
    //this.add.image(startX, startY, 'bg');
    this.anims.create({
      key: 'left',
      frames: this.anims.generateFrameNumbers('dude', { start: 5, end: 6 }),
      frameRate: 1,
      repeat: -1
    })

    this.anims.create({
      key: 'leftHurt',
      frames: [ { key: 'dude', frame: 11 } ],
      frameRate: 20,
    })

    this.anims.create({
      key: 'leftJump',
      frames: [ { key: 'dude', frame: 9 } ],
      frameRate: 20,
    })
    this.anims.create({
      key: 'leftJumpDown',
      frames: [ { key: 'dude', frame: 10 } ],
      frameRate: 20,
    })

    this.anims.create({
      key: 'turn',
      frames: this.anims.generateFrameNumbers('dude', { start: 0, end: 2 }),
      frameRate: 3,
      repeat: -1
    })

    this.anims.create({
      key: 'right',
      frames: this.anims.generateFrameNumbers('dude', { start: 3, end: 4 }),
      frameRate: 1,
      repeat: -1
    })

    this.anims.create({
      key: 'rightHurt',
      frames: [ { key: 'dude', frame: 12 } ],
      frameRate: 20,
    })
    this.anims.create({
      key: 'rightJump',
      frames: [ { key: 'dude', frame: 7 } ],
      frameRate: 20,
    })
    this.anims.create({
      key: 'rightJumpDown',
      frames: [ { key: 'dude', frame: 8 } ],
      frameRate: 20,
    })



    this.scene.start('MainScene')
  }
}



